import { Helmet } from "react-helmet";
import Anchor from "components/anchor";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import collectionMeta from "content/collections/coastal-carpet-python.json";
import { animalGridFromJson } from "hooks/useGallery";

const animalGridData = animalGridFromJson(collectionMeta);

const CoastalCarpetPython = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Coastal Carpet Pythons (Morelia spilota mcdowelli)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/coastal-carpet-python" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />
      <AnimalGrid data={animalGridData} />
      <BodyText>
        Coastal Carpet pythons can be beautiful in their own right but I went
        for one with the Jaguar trait because the look they have is next-level.
        Obviously I have to address the "wobble" concerns by stating that my Jag
        Coastal will roam around her cage without any signs of wobbling unless
        she starts poking her head upward and noses around near the ceiling.
        Then she's bound to get her head upside-down and wobble as she gets
        herself righted.
      </BodyText>
      <BodyText>
        But I work from home in the same room where she is and her cage is very
        visible from my desk and I rarely see her have problems with her
        balance. Plus she's easy to handle and stunningly beautiful so I don't
        have any regrets about having her. In fact, I even plan to breed her
        some years because other people also want beautiful Jaguar coastals. I
        am assuming though that if I ever produce one with a severe equilibrium
        problem I will cull the snake.
      </BodyText>
      <BodyText>
        Interestingly{" "}
        <Anchor href="https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0262788">
          {" "}
          this paper{" "}
        </Anchor>
        was published in 2022 where the authors examined ball pythons of the
        Spider morph and determined that the equilibrium problems were caused by
        differences in the inner ear structure of the affected snakes. It is
        widely assumed that Coastal Carpet pythons with the Jaguar trait suffer
        because of similar conditions.
      </BodyText>
      <BodyText>
        I'm not sure if I'll ever get more Coastals in the future simply because
        of space concerns. I'm not a big fan of striped snakes for some reason
        so the Tiger gene isn't appealing to me, but I would be interested in
        the standard, banded look that many Coastals have. We'll see.
      </BodyText>
      <PageGallery slug="coastal-carpet-python" maxWidth="900" />
    </ContentBox>
  );
};

export default CoastalCarpetPython;
